module.exports = __webpack_public_path__ + "img/rep-jessica.f1b2902b.png";